import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BECCECoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Computer and Communication Engineering",
    shortName: "B.E. CCE",
    duration: "4 years",
    description: "Specialized engineering program combining computer systems with communication technologies for modern network infrastructure",
    overview: "Bachelor of Engineering in Computer and Communication Engineering (B.E. CCE) is a 4-year undergraduate program that integrates computer science principles with communication engineering. This interdisciplinary course focuses on developing skills in networking, data communication, wireless systems, and computer hardware-software integration essential for modern telecommunications and IT infrastructure.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry", 
          "Programming in C",
          "Engineering Graphics",
          "Basic Electronics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Digital Electronics",
          "Electronic Devices and Circuits",
          "Object-Oriented Programming",
          "Network Theory",
          "Discrete Mathematics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Computer Networks",
          "Communication Systems",
          "Microprocessors and Microcontrollers",
          "Database Management Systems",
          "Signal Processing",
          "Wireless Communications"
        ]
      },
      {
        year: 4,
        subjects: [
          "Network Security",
          "Mobile Communications",
          "Distributed Systems",
          "Internet of Things",
          "Project Work",
          "Industry Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Network Engineer",
        "Communication Systems Engineer", 
        "Network Security Specialist",
        "Telecom Engineer",
        "Systems Administrator",
        "Technical Support Engineer",
        "RF Engineer",
        "Network Architect"
      ],
      industries: [
        "Telecommunications Companies",
        "Internet Service Providers",
        "IT Services Companies",
        "Network Equipment Manufacturers",
        "Government Organizations",
        "Research Institutions",
        "Consulting Firms",
        "Defense Organizations"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "BSNL, Airtel, Jio",
        "Cisco, Juniper Networks",
        "TCS, Infosys, Wipro",
        "Tech Mahindra, HCL",
        "Nokia, Ericsson",
        "IBM, Microsoft"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams", 
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000", 
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Thiagarajar College of Engineering",
        location: "Madurai",
        fees: "₹3,20,000",
        ranking: "NIRF Ranking: 78"
      },
      {
        name: "Sri Sivasubramaniya Nadar College of Engineering",
        location: "Chennai", 
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Network Programming",
      "Communication Protocols",
      "Network Security",
      "Wireless Technologies",
      "Database Management",
      "System Administration",
      "Signal Processing",
      "Hardware-Software Integration",
      "Problem Solving",
      "Technical Documentation"
    ],

    futureScope: "Excellent growth opportunities in telecommunications, IoT, 5G technology, network security, and emerging communication technologies with increasing demand for skilled network professionals.",

    faqs: [
      {
        question: "What is the difference between CCE and CSE?",
        answer: "CCE focuses more on communication systems, networking, and hardware-software integration, while CSE emphasizes software development and programming."
      },
      {
        question: "Are there good placement opportunities?",
        answer: "Yes, especially in telecom companies, networking firms, and IT services with growing demand for network specialists."
      },
      {
        question: "Can CCE graduates work in software companies?",
        answer: "Absolutely! Many CCE graduates work in software companies, especially in networking, system programming, and technical support roles."
      },
      {
        question: "What are the higher study options?",
        answer: "M.E./M.Tech in Communication Systems, Networking, MBA, or specialized certifications in networking technologies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BECCECoursePage;
